import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListEventSettingPayload } from '@app-store/slices/eventSettings/list'

interface TaskAction extends Action {
    payload: IListEventSettingPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.eventSetting.list

function* listEventSettingSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/event/settings`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listEventSettingSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listEventSettingSagaTask)
}

export default listEventSettingSaga
